import SubmitButton from "./SubmitButton";

<div style={{ maxWidth: "600px" }}>
## Basic Usage

export function BasicSubmit() {
  return <SubmitButton>{"Submit"}</SubmitButton>;
}

<BasicSubmit />

---

## Styles

export function StylesExample() {
  return (
    <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
      <SubmitButton>{"Primary"}</SubmitButton>
      <SubmitButton secondary>{"Secondary"}</SubmitButton>
    </div>
  );
}

<StylesExample />

---

## Disabled State

export function DisabledExample() {
  return (
    <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
      <SubmitButton disabled>{"Disabled Primary"}</SubmitButton>
      <SubmitButton secondary disabled>
        {"Disabled Secondary"}
      </SubmitButton>
    </div>
  );
}

<DisabledExample />

---

## In a Form Context

export function FormExample() {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        alert("Form submitted!");
      }}
      style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "300px" }}
    >
      <input
        type="text"
        placeholder="Enter your name"
        style={{ padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
      />
      <div style={{ display: "flex", gap: "0.5rem" }}>
        <SubmitButton secondary>{"Cancel"}</SubmitButton>
        <SubmitButton>{"Submit"}</SubmitButton>
      </div>
    </form>
  );
}

<FormExample />
</div>
